<script lang="ts">
  import type { UserEvent } from '../../lib/pandalytics';
  import { getEventReport } from '../../lib/pandalytics';
  import { getEventFeed } from '../../lib/pandalytics';
  import Scroller from '../Scroller.svelte';
  import Lazy from 'svelte-lazy';
  import Page from '../Page.svelte';
  import EventTable from './EventTable.svelte';
  import { onMount, tick } from 'svelte';
  import { Select } from 'svelte-materialify';

  export let params: { project: string };

  let isLoading = false;
  let disableLazy = false;
  let page = 1;
  let limit = 50;
  let totalEvents = Infinity;

  let events: UserEvent[] = [];
  let allActions: string[] = [];
  let defaultActions = ['ITEM_CLICK', 'BOOKMARK_ADD'];
  let selectedActions: string[] = [];
  let previousActionLength: number = 0;
  let clearButton: HTMLDivElement;

  $: isFinished = events.length >= totalEvents;
  $: onSelectedActionsChange(selectedActions);

  onMount(async () => {
    const { result } = await getEventReport({
      project: params.project,
      name: 'distinctActions',
    });

    allActions = result.filter((data) => !data.startsWith('BANNER_SHOW'));

    selectedActions = defaultActions.filter((action) =>
      allActions.find((a) => a === action)
    );

    fetchEvents(true);
  });

  async function fetchEvents(reset?: boolean) {
    isLoading = true;

    if (reset) {
      page = 1;
      events = [];
    } else if (isFinished) {
      return;
    }

    try {
      const res = await getEventFeed({
        project: params.project,
        page,
        limit,
        actions: selectedActions,
      });

      events = [...events, ...res.docs];
      totalEvents = res.total;
      await tick();
      disableLazy = false;
    } catch (error) {}

    isLoading = false;
  }

  function onScrollEnded() {
    page++;
    fetchEvents();
    disableLazy = true;
  }

  async function onSelectedActionsChange(selectedActions: string[]) {
    if (selectedActions.length === previousActionLength) return;

    previousActionLength = selectedActions.length;
    fetchEvents(true);
  }

  function eventActions() {
    let sMenu = document.querySelector('.s-menu');
    sMenu.appendChild(clearButton);
    clearButton.style.display = 'block';
  }

  function clearSelected() {
    selectedActions = [];
  }
</script>

<Page title="Feed">
  <div class="event-actions" slot="actions" on:click={eventActions}>
    <Select multiple items={allActions} bind:value={selectedActions}>Actions</Select>
    <div id="clear-button" bind:this={clearButton} on:click={clearSelected}>
      <small>❌</small> Clear All
    </div>
  </div>
  <Scroller>
    {#if events.length}
      <EventTable {events} project={params.project} />

      {#if !disableLazy}
        <Lazy offset={500} onload={onScrollEnded}>Loading...</Lazy>
      {/if}
    {/if}
  </Scroller>
</Page>

<style lang="scss">
  #clear-button {
    position: sticky;
    bottom: 0;
    background-color: #f0f0f0;
    color: #ec0000;
    padding: 14px 18px;
    z-index: 100;
    box-shadow: 0px 0px 10px #7d8aa8;
    display: none;
  }
</style>
